import React from "react";
import {
  LayoutDashboard,
  Users,
  CalendarDays,
  UserPlus,
  Handshake,
  ClipboardList,
  CircleHelp,
  LayoutTemplate,
  Info,
  Shield,
  ShieldCheck,
  Trash2,
} from "lucide-react";

const menuIcon = (Icon) => (
  <Icon size={20} strokeWidth={1.75} color="currentColor" aria-hidden />
);

export const MenuList = [
  {
    title: "Dashboard",
    classsChange: "mm-collapse",
    iconStyle: menuIcon(LayoutDashboard),
    to: "/dashboard",
  },
  {
    title: "User Management",
    classsChange: "mm-collapse",
    iconStyle: menuIcon(Users),
    to: "/user-management",
  },
  {
    title: "Events",
    classsChange: "mm-collapse",
    iconStyle: menuIcon(CalendarDays),
    to: "/events",
  },
  {
    title: "New Users",
    classsChange: "mm-collapse",
    iconStyle: menuIcon(UserPlus),
    to: "/new-users",
  },
  {
    title: "Partners",
    classsChange: "mm-collapse",
    iconStyle: menuIcon(Handshake),
    content: [
      {
        title: "Dashboard",
        to: "/partners-dashboard",
      },
      {
        title: "Partners",
        to: "/partners",
      },
      {
        title: "Packages",
        to: "/package",
      },
    ],
  },
    {
    title: "Disabled Acounts",
    classsChange: "mm-collapse",
    iconStyle: menuIcon(Trash2),
    to: "/delete-requests",
  },
  {
    title: "Plans",
    classsChange: "mm-collapse",
    iconStyle: menuIcon(ClipboardList),
    to: "/subscriptions",
  },
  {
    title: "FAQS",
    classsChange: "mm-collapse",
    iconStyle: menuIcon(CircleHelp),
    to: "/faqs",
  },
  {
    title: "Template",
    classsChange: "mm-collapse",
    iconStyle: menuIcon(LayoutTemplate),
    to: "/template",
  },
  {
    title: "About Us",
    classsChange: "mm-collapse",
    iconStyle: menuIcon(Info),
    to: "/about-us",
  },
  {
    title: "Privacy Policy",
    classsChange: "mm-collapse",
    iconStyle: menuIcon(Shield),
    to: "/privacy-policy",
  },
  {
    title: "Refund Policy",
    classsChange: "mm-collapse",
    iconStyle: menuIcon(ShieldCheck),
    to: "/refund-policy",
  },

];
